module.exports = __webpack_public_path__ + "img/KFK_COVER.4632736f.png";